import React from 'react';
import glamorous from 'glamorous';

import ImgWithSource from './img-with-source';
import htmlEnc1Img from '../../../assets/images/docs/html-encoding/html-encoding-1.png';

const HtmlEncoding = () => {
  return (
    <div>
      <h3>
        HTML ENCODING
      </h3>
      <p>
        All information embedded in an XML field <strong>MUST</strong> be HTML-encoded.
      </p>
      <div>
        <p>
          This means that all special characters that are used in HTML should be replaced with their corresponding HTML
          entities. For example, at least the following 3 replacements should be done:
        </p>
        <glamorous.Div css={{ width: 350 }}>
          <glamorous.Table
            className="table table-condensed table-striped table-bordered table-hover"
            css={{ textAlign: 'center' }}
          >
            <thead>
            <tr>
              <th>Special character (in the textual field)</th>
              <th>HTML encoded value</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>&</td>
              <td>{`&amp;`}</td>
            </tr>
            <tr>
              <td>{`>`}</td>
              <td>{`&gt;`}</td>
            </tr>
            <tr>
              <td>{`<`}</td>
              <td>{`&lt;`}</td>
            </tr>
            </tbody>
          </glamorous.Table>
        </glamorous.Div>
      </div>
      <br/>
      <p>
        You can use free online tools (e.g. <a
        href="https://www.web2generators.com/html-based-tools/online-html-entities-encoder-and-decoder"
        target="_blank">https://www.web2generators.com/html-based-tools/online-html-entities-encoder-and-decoder</a>) to
        create the right HTML-encoded values (see example below).
      </p>
      <ImgWithSource src={htmlEnc1Img}/>
    </div>
  );
};

export default HtmlEncoding;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/html-encoding.js